import React from 'react';
import GroupIcon from '../../images/group_of_people.svg';
import ThreePeopleIcon from '../../images/three_people.svg';

const PreFooter = () =>
  (<section className="pre-footer">
    <div className="container">
      <div className="row">
        <div className="pre-footer__column col-sm-4">
          <div className="pre-footer__box">
            <i className="c-icon c-icon--check_circle"></i>
            <h3 className="pre-footer__text">seit <br/> 1950</h3>
          </div>
        </div>
        <div className="pre-footer__column col-sm-4">
          <div className="pre-footer__box">
            <div className="pre-footer__custom-icon">
              <img className="pre-footer__custom-icon__image" src={ThreePeopleIcon} alt="Partner Ikon" />
            </div>
            <h3 className="pre-footer__text">4 <br/> Partner</h3>
          </div>
        </div>
        <div className="pre-footer__column col-sm-4">
          <div className="pre-footer__box">
            <div className="pre-footer__custom-icon">
              <img className="pre-footer__custom-icon__image" src={GroupIcon} alt="Group Ikon" />
            </div>
            <h3 className="pre-footer__text">20+ <br/> Mitarbeiter</h3>
          </div>
        </div>
      </div>
    </div>
  </section>);

export default PreFooter;



// WEBPACK FOOTER //
// ./src/components/pre-footer/index.js